import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { mediumConstants as medium, smallConstants as small } from './styleConstantsBySize.js';
import { Rating as Rating$2, RatingImage, Plus } from './style.js';
import { ratingTexts } from './Rating.texts.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var _excluded = ["className", "rating", "size", "responsive", "globe", "siteId"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Rating = function Rating(_ref) {
  var className = _ref.className,
    rating = _ref.rating,
    size = _ref.size,
    responsive = _ref.responsive,
    globe = _ref.globe,
    siteId = _ref.siteId,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (typeof rating !== 'number') {
    return false;
  }
  if (rating < 2 || rating > 11) {
    return false;
  }
  var styleConstants;
  switch (size) {
    case 'small':
      styleConstants = small;
      break;
    case 'medium':
    default:
      styleConstants = medium;
  }
  var ariaLabelText = ratingTexts[siteId].standard;
  var ratings = [];
  for (var i = 0; i < Math.floor(rating / 2); i += 1) {
    ratings.push( /*#__PURE__*/jsx(RatingImage, {
      constants: styleConstants,
      responsive: responsive,
      rating: Math.floor(rating / 2),
      globe: globe
    }, i));
  }
  var getAriaLabel = function getAriaLabel() {
    var ratingValue = Math.floor(rating / 2);
    var hasPlus = rating % 2 === 1;
    return "".concat(ariaLabelText, " ").concat(ratingValue).concat(hasPlus ? '+' : '');
  };
  return /*#__PURE__*/jsxs(Rating$2, _objectSpread(_objectSpread({
    className: className,
    fontSize: styleConstants.plusSignFontSize,
    hasPlus: rating % 2 === 1,
    globe: globe,
    "aria-label": getAriaLabel()
  }, rest), {}, {
    children: [ratings, rating % 2 === 1 && /*#__PURE__*/jsx(Plus, {
      "aria-hidden": "true",
      children: "+"
    })]
  }));
};
Rating.defaultProps = {
  className: null,
  size: 'medium',
  responsive: false,
  globe: false,
  ariaLabelText: '',
  siteId: 1
};
var Rating$1 = Rating;

export { Rating$1 as default };
//# sourceMappingURL=_Rating.js.map
